import { get } from '../..';

const getFloorData = (BuildingId: string) => get(`locations/floors?ParentId=${BuildingId}`);

export default getFloorData;
